<div
  class="table__header"
  [ngClass]="{
    'multiple-select': ztService.zipTableOptions.selection.multiple,
  }"
>
  @if (((detailView && multiExpandedAllowed) || grouping) && dataExists) {
    <div class="table__row__expand">
      <icon
        [name]="allExpanded ? 'unfold_less' : 'unfold_more'"
        [config]="{ type: 'pointer' }"
        (click)="expandAllRows.emit()"
      >
      </icon>
    </div>
  }

  @if (ztService.zipTableOptions.selection.multiple) {
    <input
      class="form-control form-control--checkbox table--checkbox header--checkbox"
      type="checkbox"
      [checked]="ztService.allRowsAreSelected"
      (change)="markAllRowsAsSelected($event)"
    />
  }

  @if (
    ztService.zipTableOptions.selection.editHeader &&
    ztService.selectedRow.length > 0
  ) {
    <div class="table__cell table__cell--header u-relative" role="columnheader">
      <p class="t-data t-bold">
        {{ ztService.selectedRow.length }} rows selected
      </p>
      <div class="button__group">
        @if (checkHeaderButton(HeaderButtonType.EDIT)) {
          <zip-button
            (zipButtonClicked)="editClicked.emit($event)"
            [level]="
              ztService.zipTableOptions?.selection?.editHeaderConfig?.edit
                ?.level || 'low'
            "
            icon="edit"
            content="Edit"
          >
          </zip-button>
        }
        @if (checkHeaderButton(HeaderButtonType.DELETE)) {
          <zip-button
            (zipButtonClicked)="deleteClicked.emit($event)"
            [level]="
              ztService.zipTableOptions?.selection?.editHeaderConfig?.delete
                ?.level || 'low'
            "
            icon="trash"
            [content]="checkDeleteText('Delete')"
          >
          </zip-button>
        }
        @for (
          headerButton of ztService.zipTableOptions.selection.editHeaderConfig
            ?.headerButtons;
          track headerButton
        ) {
          <div class="headerButton">
            @if (!headerButton.isHidden) {
              <zip-button
                (zipButtonClicked)="
                  headerButtonClicked.emit(ztService.selectedRow)
                "
                [level]="
                  ztService.zipTableOptions?.selection?.editHeaderConfig
                    ?.headerBtns?.level || 'low'
                "
                [icon]="headerButton.icon"
                [content]="headerButton.content"
                [ngClass]="headerButton.customCSSClass"
              >
              </zip-button>
            }
          </div>
        }
      </div>
    </div>
  } @else {
    @for (column of columns; track column; let i = $index) {
      @if (!column.isHidden) {
        <table-header-cell
          [ngClass]="getCSSClasses(column)"
          [attr.title]="column.tooltip"
          class="table__cell table__cell--header u-relative"
          [sorts]="options?.sorts"
          [column]="column"
          [dataExists]="dataExists"
          (headerButtonClicked)="headerButtonClicked.emit($event)"
          (onSortByField)="fireSortEvent($event)"
          [stackedIcons]="options?.sorting?.stackedIcons"
          role="columnheader"
        >
        </table-header-cell>
      }
    }
  }
</div>
